import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { GetLiveCoreOddsQueryQuery } from "@/graphql/gql/graphql";
import { getLiveCoreOdds } from "../api";

const useLiveCoreOdds = (
  gameId: number,
  queryOptions: Partial<UseQueryOptions<GetLiveCoreOddsQueryQuery>> = {}
) => {
  const { data, isLoading, isError } = useQuery({
    ...queryOptions,
    queryKey: ["getLiveOdds", gameId],
    queryFn: () => getLiveCoreOdds(gameId),
  });

  return {
    data,
    isLoading,
    isError,
  };
};

export default useLiveCoreOdds;
